import { render, staticRenderFns } from "./Lottosets.vue?vue&type=template&id=6afd5fc1&"
import script from "./Lottosets.vue?vue&type=script&lang=js&"
export * from "./Lottosets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports